import { tokens } from "@/shared/design-system/tokens";
import styled from "@emotion/styled";

const MOBILE_MAX_WIDTH = tokens.breakpoints.md - 1;

export const AppShell = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
`;

export const MainContent = styled.main`
  margin-top: 60px;
  width: 100%;
  height: calc(100vh - 60px);
  height: calc(100dvh - 60px);
  min-height: 0;
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
  position: relative;
  z-index: 1;
  align-items: stretch;

  @media (max-width: ${MOBILE_MAX_WIDTH}px) {
    min-width: 0;
  }
`;

export const NavigationSlot = styled.div`
  display: contents;
`;

export const RouteViewport = styled.div`
  flex: 1;
  width: 0;
  min-width: 0;
  min-height: 0;
  overflow-x: hidden;
  position: relative;
  margin-bottom: 44px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.95) rgba(255, 255, 255, 0.06);

  @media (max-width: ${MOBILE_MAX_WIDTH}px) {
    width: 100%;
    height: 100%;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    margin-bottom: 0;
    overscroll-behavior-y: contain;
    -webkit-overflow-scrolling: touch;
  }
`;
